import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const travelHighlightEntity: Entity = {
  model: model,
  repository: repository,
}

export default travelHighlightEntity
